/* eslint-disable @typescript-eslint/ban-types */
import { ReactNode, useMemo } from 'react';
import { css } from '@emotion/react';

import { UxGoodsCardItemForVerticalProductCard } from '../vertical-product-card/types';
import * as cssVariables from './constants/cssVariables';
import { VirtuosoContextType } from './types';

export interface ItemContentContainerProps<D extends UxGoodsCardItemForVerticalProductCard, P extends {}> {
  parentIndex: number;
  items: D[];
  context: VirtuosoContextType<D, P>;
  renderProductCard: (item: D, itemIndex: number, context: VirtuosoContextType<D, P>) => ReactNode;
}

export const ItemContentContainer = <D extends UxGoodsCardItemForVerticalProductCard, P extends {}>(
  props: ItemContentContainerProps<D, P>,
) => {
  const { parentIndex, items, context, renderProductCard } = props;

  const { columnCount, banner } = context;

  // useMemo로 render 함수를 만들어서 처리하는게 안티패턴(?)인지 애매하지만 일단 여기서는 써도 될 것 같아서 적용했습니다.
  // 이슈가 있으면 별도 컴포넌트로 분리해서 banner, items, parentIndex를 props로 넘겨주는 방식으로 변경해야 할 것 같습니다.
  const renderBanner = useMemo(() => {
    return banner && banner(items, parentIndex);
  }, [banner, items, parentIndex]);

  const hasBanner = !!banner && !!renderBanner;

  return (
    <>
      <div css={rowCss}>
        {items.map((item, index) => {
          if (!item) return null;

          const itemIndex = parentIndex * columnCount + index;

          return (
            <div css={colCss} key={itemIndex}>
              {renderProductCard(item, itemIndex, context)}
            </div>
          );
        })}
      </div>
      {hasBanner && (
        <div css={rowCss}>
          <div css={bannerWrapperCss}>{renderBanner}</div>
        </div>
      )}
    </>
  );
};

const colCss = css`
  width: 100%;
  max-width: calc(100% / var(${cssVariables.column}));
  box-sizing: border-box;
  padding: 0 1px;
`;

const rowCss = css`
  .basic &,
  .content & {
    width: calc(100% + 2px);
    margin-left: -1px;
    margin-right: -1px;
  }

  display: flex;
  margin-bottom: 24px;
`;

const bannerWrapperCss = css`
  width: 100%;
  padding: 0 4px;
  box-sizing: border-box;
`;
